import React, { FC } from 'react';

import { Loader } from 'src/Loader/Loader';

import { Layout } from './Layout';
import { Message, MessageType } from './Message';
import messages from './messages';

export interface LoadingStateProps {
  message?: MessageType;
  resource?: string;
}
export const LoadingState: FC<LoadingStateProps> = ({ message = 'search request', resource = '' }) => {
  const text = resource ? (
    <Message definedMessage={messages.loading} values={{ resource }} />
  ) : (
    <Message message={message} />
  );

  const loader = <Loader />;

  return <Layout nodes={[text, loader]} />;
};
